import React, { ReactNode } from "react";
import DashboardComponent from "../components/layout/dashboard";
import DrawerContainer from "../components/drawer-container/drawer-container";
import ModalContainer from "../components/modal-container/modal-container";
import ToastContainer from "../components/toast-container/toast-container";

interface DashboardLayoutProps {
  children: ReactNode;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  return (
    <DashboardComponent>
      <div
        style={{ marginTop: "4.2rem", height: "100%", backgroundColor: "#fff" }}
      >
        {children}
      </div>
      <DrawerContainer />
      <ModalContainer />
      <ToastContainer />
    </DashboardComponent>
  );
};

export default DashboardLayout;
